import React from 'react';
import PropTypes from 'prop-types';
import { RichText, Elements } from 'prismic-reactjs';

import { Typography, List } from '../base';

const propsWithUniqueKey = (props, key) => {
  return Object.assign(props || {}, { key });
};

const htmlSerializer = (type, element, content, children, key) => {
  let props = {
    key,
    children,
  };

  switch (type) {
    case Elements.heading1:
      return <Typography.H1 {...props} />;

    case Elements.heading2:
      return <Typography.H2 {...props} />;

    case Elements.heading3:
      return <Typography.H3 {...props} />;

    case Elements.heading4:
      return <Typography.H4 {...props} />;

    case Elements.heading5:
      return <Typography.H5 {...props} />;

    case Elements.heading6:
      return <Typography.H6 {...props} />;

    case Elements.paragraph:
      return <Typography.P {...props} />;

    case Elements.list:
      return <List styled {...props} />;

    case Elements.oList:
      return <List ordered {...props} />;

    case Elements.listItem:
    case Elements.oListItem:
      return <List.Item {...props} />;

    case Elements.image:
      props = { src: element.url, alt: element.alt || '' };
      return React.createElement('img', propsWithUniqueKey(props, key));

    default:
      return null;
  }
};

const PrismicHtmlContent = props => {
  if (props.content == null) {
    return null;
  }
  return <RichText render={props.content} htmlSerializer={htmlSerializer} />;
};

PrismicHtmlContent.propTypes = {
  content: PropTypes.any,
};

export default PrismicHtmlContent;
